import navigationItems from '../navigationItems/index.js';

var footerLegalNavigation = {
  tsc: navigationItems.tc,
  privacy: navigationItems.privacy,
  ethyca: navigationItems.ethyca,
  communityGuidelines: navigationItems.communityGuidelines,
  interestBasedAds: navigationItems.interestBasedAds,
  DMCA: navigationItems.DMCA,
  securityPolicy: navigationItems.securityPolicy
};

export { footerLegalNavigation as default };
//# sourceMappingURL=index.js.map
